import { useRoute } from 'vue-router'

export default defineNuxtPlugin((nuxtApp) => {
  // List of routes that should always show body only

  let showBodyOnly = false
  let noPanel = false

  // Use Nuxt's useRoute composable for consistent SSR/CSR route detection
  const route = useRoute()

  const query = route.query

  // Check query params and route matches
  showBodyOnly = Boolean(query.showBodyOnly)
  noPanel = Boolean(query.noPanel)

  // Inject the result into the context as $showBodyOnly and $noPanel
  nuxtApp.provide('showBodyOnly', showBodyOnly)
  nuxtApp.provide('noPanel', noPanel)
})
